import React from 'react';
import { Col, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import ImagemDuvida from 'assets/img/Dicionario.svg';
import { publicRoot, requerimentos, rotaAtendente } from 'routes/paths';
import { fetchGetTodosStatus } from 'store/fetchActions/fetchInputForm';
import * as S from './styles';
import * as Style from 'components/Style';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { altImageDuvida } from 'utils/acessibilidade';

export default function DicionarioSistema() {
  const dispatch = useDispatch();

  const user = useSelector(state => state.sefaz.userProfile);
  const listaStatus = useSelector(state => state.status.todosStatus);

  React.useEffect(() => {
    dispatch(fetchGetTodosStatus(listaStatus));
    // eslint-disable-next-line
  }, [dispatch]);

  const esconderLinkContribuinte = (texto, rota) => {
    return user?.profile !== ENUM_TIPO_PERFIL.CONTRIBUINTE ? (
      <a data-testid="link" href={rota}>
        {texto}
      </a>
    ) : (
      texto
    );
  };

  return (
    <S.Page>
      <Style.GlobalCard>
        <Row>
          <Col xs={24} sm={24} md={24} lg={15} xl={15}>
            <S.Titulo>FAS</S.Titulo>
            <S.Descricao>
              O FAS (Formulário de Atendimento SEFAZ) é um sistema para que o cidadão possa realizar solicitações de
              serviços ou até mesmo tirar suas dúvidas, independente do assunto. Para realizar essas ações o
              contribuinte deve preencher um formulário, disponível na <a href={publicRoot}>tela inicial</a> do sistema,
              esse formulário é chamado de requerimento.
            </S.Descricao>

            <S.Titulo>Requerimentos</S.Titulo>
            <S.Descricao>
              Para o <b>Contribuinte</b> realizar uma solicitação, o mesmo preenche um formulário padrão, disponível na{' '}
              <a href={publicRoot}>tela inicial</a> do sistema, nesse formulário o contribuinte pode informar se é
              pessoa Física ou Jurídica, seu endereço e o tipo de solicitação, entre outros campos, o contribuinte tem a
              opção de anexar arquivos em PDF que não ultrapassem 10MB, e preencher o campo &quot;Justificativa&quot;
              para detalhar sua solicitação.
            </S.Descricao>

            <S.Titulo>Perfil Contribuinte, Supervisor, Atendente, Supervisor Setorial e Atendente Setorial</S.Titulo>
            <S.Descricao>
              <b>Contribuinte</b> é o cidadão do município de Salvador, que pode realizar solicitações, como Certidão
              positiva de débitos, Cancelamento de PAD, 2ª via de tributos ou até mesmo tirar suas dúvidas, independente
              do assunto. Para realizar essas ações o contribuinte deve preencher um formulário, no sistema chamado de
              requerimento, disponível na <a href={publicRoot}>tela inicial</a> do sistema.
            </S.Descricao>
            <S.Descricao>
              <b>Supervisor</b> é o funcionário da SEFAZ, cadastrado no sistema FAS e pode acompanhar todos os
              requerimentos e o status de cada um deles, podendo também cadastrar novos atendentes ou supervisores,
              editar dados e responder requerimentos.
            </S.Descricao>
            <S.Descricao>
              <b>Supervisor Setorial</b> é o funcionário da SEFAZ, cadastrado no sistema FAS e pode acompanhar todos os
              requerimentos do seu setor, e o status de cada um deles, não pode cadastrar novos usuários ou editar dados
              dos funcionários, pode responder, encaminhar ou iniciar atendimento de um requerimento.
            </S.Descricao>
            <S.Descricao>
              <b>Atendente</b> é o responsável pelo atendimento dos requerimentos, garantindo o suporte necessário ao
              contribuinte. Todos os requerimentos atribuídos ao atendente ficam disponíveis na{' '}
              {esconderLinkContribuinte('página de listar', requerimentos)}, localizado no menu superior do sistema.
            </S.Descricao>
            <S.Descricao>
              <b>Atendente Setorial</b> é o responsável pelo atendimento de um determinado assunto, geralmente
              relacionado a outros setores, somente um Atendente pode passar um requerimento para o Atendente Setorial
              solucionar.
            </S.Descricao>

            <S.Titulo>Atendimento</S.Titulo>
            <S.Descricao>
              O Atendente pode iniciar atendimento na{' '}
              {esconderLinkContribuinte('página inicial do atendente', rotaAtendente)}, clicando no botão &quot;Iniciar
              Atendimento&quot;, então o sistema deve encaminhar para sua lista um novo requerimento para atendimento.
              Na {esconderLinkContribuinte('lista de atendimento', requerimentos)} é possível verificar o histórico,
              onde ficam salvas as alterações feitas no requerimento, ou detalhar o requerimento para ter acesso a mais
              informações. Também é possível filtrar um atendimento específico, por status, protocolo e outras opções.
            </S.Descricao>

            <S.Titulo>Detalhar requerimento</S.Titulo>
            <br />
            <S.Descricao>
              O Atendente ou Supervisor, ao detalhar um requerimento, podem <b>Salvar Status</b>, que salva no histórico
              do requerimento os dados digitados no campo &quot;Justificativa&quot;, esse histórico fica disponível para
              todos. (Atendente, Contribuinte, Atendente Setorial e Supervisor). O status do requerimento continua o
              mesmo.
            </S.Descricao>
            <S.Descricao>
              O Atendente ou Supervisor, ao detalhar um requerimento, podem <b>Salvar e Devolver</b>, que salva no
              histórico do requerimento os dados digitados no campo &quot;Justificativa&quot;, e devolver o formulário
              ao contribuinte. O status do requerimento é alterado para &quot;Devolvido ao Contribuinte&quot;
            </S.Descricao>
            <S.Descricao>
              O Atendente ou Supervisor, ao detalhar um requerimento, podem <b>Finalizar Atendimento</b>, que salva no
              histórico do requerimento os dados digitados no campo &quot;Justificativa&quot;, e finaliza o
              requerimento. O contribuinte recebe um e-mail com a informação de que o requerimento foi finalizado e uma
              pesquisa de satisfação. O status do requerimento é alterado para &quot;Finalizado&quot;
            </S.Descricao>
            <S.Descricao>
              O Atendente ou Supervisor, ao detalhar um requerimento que esteja com o status &quot;Em Atendimento&quot;
              podem <b>Alterar para Em Análise</b>, que salva no histórico do requerimento os dados digitados no campo
              &quot;Justificativa&quot;, e altera o status do requerimento para Em Análise, permitindo que o atendente
              possa iniciar um novo atendimento.
            </S.Descricao>
            <S.Descricao>
              O Atendente também pode <b>Encaminhar atendimento</b>, onde são exibidas novas opções para encaminhar o
              requerimento para algum setor. O Atendente escolhe qual setor deseja encaminhar, digita os dados no campo
              &quot;Justificativa&quot;, e aperta em <b>Encaminhar</b>. Com essa ação o requerimento passa a ter o
              status de &quot;Encaminhado para atendimento&quot; e fica na lista aguardando um atendente setorial
              iniciar o atendimento.
            </S.Descricao>
            <S.Descricao>
              O Supervisor pode <b>Cancelar Requerimento</b>, onde o requerimento passa a ficar com o status de
              &quot;cancelado&quot;. Os dados ficam salvos no histórico do requerimento.
            </S.Descricao>
            <S.Descricao>
              O Atendente Setorial pode <b>Encaminhar</b>, onde o requerimento é devolvido ao atendente que encaminhou o
              requerimento anteriormente.
            </S.Descricao>
            <S.Descricao>
              O Atendente Setorial pode <b>Devolver ao Contribuinte</b>, que salva no histórico do requerimento os dados
              digitados no campo &quot;Justificativa&quot;, e devolver o formulário ao contribuinte.
            </S.Descricao>
            <S.Descricao>
              O Atendente Setorial pode <b>Salvar Status</b>, que salva no histórico do requerimento os dados digitados
              no campo &quot;Justificativa&quot;.
            </S.Descricao>
            <S.Descricao>
              O campo justificativa tem um limite de dois mil caracteres, e é possível anexar arquivos no formato PDF de
              até 10MB.
            </S.Descricao>

            <S.Titulo>Status</S.Titulo>
            <S.Descricao>
              Cada requerimento pode ter um status por vez, esse status mostra em qual processo o requerimento está no
              momento. Os status são:
              <br />
              <ul>
                {listaStatus?.map(status => {
                  return (
                    <li key={status?.id}>
                      <b>{status?.descricao}</b>: {status?.significado}
                    </li>
                  );
                })}
              </ul>
            </S.Descricao>

            {user?.profile !== ENUM_TIPO_PERFIL.CONTRIBUINTE && (
              <>
                <S.Titulo>Cadastrar Atendente ou Supervisor</S.Titulo>
                <S.Descricao>
                  Para cadastrar um novo atendente ou supervisor, deve ser realizado um cadastro no eSefaz, para em
                  seguida realizar o cadastro no FAS. O contribuinte não tem acesso as informações do atendente, com
                  exceção do nome e apelido. Para <b>editar as informações</b> de um atendente, o supervisor deve
                  realizar login no sistema, listar todos os atendentes e editar as informações desejadas.
                </S.Descricao>
              </>
            )}
          </Col>
          <Col>
            <S.Imagem src={ImagemDuvida} alt={altImageDuvida} />
          </Col>
        </Row>
      </Style.GlobalCard>
    </S.Page>
  );
}
